import { Link } from 'react-router-dom'
import { RiInstagramFill, RiTiktokFill } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'
import { PROJECT_NAME, SOCIAL_LINKS, COMPANY } from '@/constants/common'
import styles from './Footer.module.css'

export function Footer() {
    const year = new Date().getFullYear()

    return (
        <footer className={styles.footer}>
            <div className={styles.row}>
                <div className={styles.links}>
                    <Link to={ROUTES.projects}>Proyectos</Link>
                    <Link to={ROUTES.orders}>Pedidos</Link>
                    <Link to={ROUTES.privacyPolicy}>Privacidad</Link>
                    <Link to={ROUTES.termsOfService}>Términos</Link>
                </div>

                <div className={styles.social}>
                    <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                        <RiInstagramFill />
                    </a>
                    <a href={SOCIAL_LINKS.tiktok} target="_blank" rel="noopener noreferrer" aria-label="TikTok">
                        <RiTiktokFill />
                    </a>
                </div>
            </div>

            <div className={styles.bottom}>
                <span>{year} {PROJECT_NAME}</span>
                <span className={styles.dot} />
                <span>
                    Hecho por{' '}
                    <a href={COMPANY.url} target="_blank" rel="noopener noreferrer">
                        {COMPANY.name}
                    </a>
                </span>
            </div>
        </footer>
    )
}
